import React from "react";
import { useNavigate } from "react-router-dom";
import TopNav from "../components/TopNav";
import { useLang } from "../lib/i18n";

export default function IntakeIneligible() {
  const nav = useNavigate();
  const { lang } = useLang();

  const content = {
    en: {
      title: "We're Unable to Proceed",
      subtitle: "Based on the information provided, we are unable to offer treatment at this time.",
      reasons: [
        "You must be at least 18 years old to use our services",
        "Certain medical conditions may make treatment unsafe",
        "Additional medical evaluation may be required",
      ],
      whatNext: "What's next?",
      contactText: "If you believe this is an error or would like to discuss your eligibility with our medical team, please contact us.",
      contactButton: "Contact Support",
      homeButton: "Return to Home",
    },
    es: {
      title: "No Podemos Continuar",
      subtitle: "Según la información proporcionada, no podemos ofrecer tratamiento en este momento.",
      reasons: [
        "Debes tener al menos 18 años para usar nuestros servicios",
        "Ciertas condiciones médicas pueden hacer que el tratamiento no sea seguro",
        "Puede ser necesaria una evaluación médica adicional",
      ],
      whatNext: "¿Qué sigue?",
      contactText: "Si crees que esto es un error o deseas discutir tu elegibilidad con nuestro equipo médico, por favor contáctanos.",
      contactButton: "Contactar Soporte",
      homeButton: "Volver al Inicio",
    },
  };

  const c = content[lang] || content.en;

  return (
    <>
      <TopNav minimal />
      <div className="aa-shell aa-center" style={{paddingTop: "100px"}}>
        <div className="aa-eyebrow" style={{color: "var(--red)"}}>
          {lang === "es" ? "No Elegible" : "Not Eligible"}
        </div>
        <h1 className="aa-h1">{c.title}</h1>
        <p className="aa-sub" style={{marginInline:"auto", marginBottom: "32px"}}>
          {c.subtitle}
        </p>

        <div style={{
          background: "rgba(255,100,100,0.1)",
          border: "1px solid rgba(255,100,100,0.3)",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          textAlign: "left",
          maxWidth: "600px",
          marginInline: "auto",
        }}>
          <h2 className="aa-h2" style={{fontSize: "1.1rem", marginBottom: "16px"}}>
            {lang === "es" ? "Razones Comunes:" : "Common Reasons:"}
          </h2>
          <ul style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}>
            {c.reasons.map((reason, idx) => (
              <li key={idx} style={{
                display: "flex",
                gap: "12px",
                marginBottom: "12px",
                color: "var(--white)",
                fontSize: "0.95rem",
              }}>
                <span style={{color: "var(--red)", fontSize: "1.2rem"}}>•</span>
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>

        <div style={{
          background: "rgba(193,127,58,0.1)",
          border: "1px solid rgba(193,127,58,0.3)",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          textAlign: "left",
          maxWidth: "600px",
          marginInline: "auto",
        }}>
          <h2 className="aa-h2" style={{fontSize: "1.1rem", marginBottom: "12px"}}>
            {c.whatNext}
          </h2>
          <p style={{color: "var(--muted)", fontSize: "0.95rem", lineHeight: "1.6"}}>
            {c.contactText}
          </p>
        </div>

        <div style={{display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap"}}>
          <button
            className="aa-btn"
            onClick={() => window.location.href = "mailto:care@antiagingbybb.com"}
            data-testid="contact-support"
          >
            {c.contactButton}
          </button>
          <button
            className="aa-btn-ghost"
            onClick={() => nav("/")}
            data-testid="return-home"
          >
            {c.homeButton}
          </button>
        </div>
      </div>
    </>
  );
}
